/*
 *  I04CONVVOLENERI18n.js
 *
 *  Created by Sébastien Hecart on 2018-03-10 18:44:53 +0000.
 *  Copyright © 2017 Sebastien Hecart. All rights reserved.
 *
 *
 */

export default {
  I04CONVVOLENER_SECTION_0_TITLE: ' ',
  I04CONVVOLENER_type: 'Type de combustible',
  I04CONVVOLENER_in_pci: 'PCI',
  I04CONVVOLENER_in_volume: 'Volume',
  I04CONVVOLENER_res_energie: 'Energie'
}
